import { Box, useTheme } from "@mui/material";
import { tokens } from "../../assets/theme";

/*
 * Count pill for sidebar entries.
 *
 * Deliberately not a MUI <Badge>: that anchors an absolutely positioned bubble to the
 * corner of whatever it wraps, which in a sidebar row means it sits on top of the label
 * text. This is a plain inline pill instead, so it takes part in normal layout — drop it
 * in MenuItem's `suffix` slot and it lands at the right edge of the row on its own.
 *
 * Renders nothing at zero, so callers can pass the count unguarded.
 */
export default function NavBadge({ count = 0 }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    if (!count || count <= 0) {
        return null;
    }

    return (
        <Box
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                // Equal min-width and height keeps a single digit circular; the padding lets
                // it grow into a pill for "12" or "99+" instead of clipping.
                height: 18,
                minWidth: 18,
                px: 0.6,
                borderRadius: "9px",
                backgroundColor: colors.redAccent[500],
                color: "#ffffff",
                fontSize: "0.68rem",
                fontWeight: 600,
                // Without this the digits sit low inside the pill.
                lineHeight: 1,
                letterSpacing: 0,
            }}
        >
            {count > 99 ? "99+" : count}
        </Box>
    );
}
